import AppForm from '../app-components/Form/AppForm';

Vue.component('contract-type-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                title:  null,
                shortcode: null,
                mymcd_code: null,
                company_contract_type_id: null,
                restaurant_id: null,
                settings: {},
                intervalTypeSettings: {},
                legalChecks: {},
            }
        }
    },

    methods: {
        goBack()
        {
            window.location.href = '/contract-types';
        },

        sanitizeDecimalPoint(val)
        {
            return (val ? val.replace(",",".") : val);
        },

        sanitizeIncorrectFloatChars(val)
        {
            val = this.sanitizeDecimalPoint(val);
            return (val ? val.replace(/[^0-9.]/,"") : val);
        },

        correctBasicInputDecimals(vmodelName,$event)
        {
            this.form.settings[vmodelName] = this.sanitizeIncorrectFloatChars($event.target.value);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/contract-type/Form.js